import React from "react";
import { func, bool } from "prop-types";
import { Button } from "react-bootstrap";

const ClearDatesButton = ({
  handleClearDates,
  fromCustomDateRangeAnalytics,
  fromInterviewDataForm,
}) => (
  <div
    className={
      fromCustomDateRangeAnalytics
        ? "d-inline-block d-flex align-items-center mr-2"
        : "d-inline-block ml-2"
    }
  >
    {fromInterviewDataForm ? (
      <Button
        variant="default"
        className="btn-as-link"
        onClick={handleClearDates}
        style={{
          fontWeight: "bold",
          color: "#425cc7",
          padding: "6px 12px",
        }}
      >
        Clear dates
      </Button>
    ) : (
      <button
        style={{ color: "#53565a" }}
        type="button"
        className="btn-as-link"
        onClick={handleClearDates}
      >
        Clear dates
      </button>
    )}
  </div>
);

ClearDatesButton.propTypes = {
  handleClearDates: func,
  fromCustomDateRangeAnalytics: bool,
  fromInterviewDataForm: bool,
};

export default ClearDatesButton;
